// extracted by mini-css-extract-plugin
module.exports = {"orange":"#e38826","darkCyan":"#006970","veryDarkCyan":"#004241","card-cs":"css-b583a33","color-picker-cs":"css-0a423d3","card__title":"css-dafed7c"};